import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface Props {
  message: string;
  onDismiss?: () => void;
  onRetry?: () => void;
}

const ErrorBanner = ({ message, onDismiss, onRetry }: Props) => (
  <div className="flex items-start gap-3 rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">
    <ExclamationTriangleIcon className="mt-0.5 h-5 w-5" />
    <div className="flex-1">
      <p>{message}</p>
    </div>
    <div className="flex items-center gap-3">
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="text-xs font-semibold uppercase tracking-wide text-red-700 transition hover:text-red-900"
        >
          Try again
        </button>
      )}
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="text-xs font-semibold uppercase tracking-wide text-red-700 transition hover:text-red-900"
        >
          Dismiss
        </button>
      )}
    </div>
  </div>
);

export default ErrorBanner;
